// extracted by mini-css-extract-plugin
module.exports = {"spinnerPage":"src-components-AppSpinner-index-module__spinnerPage--2uxy5"};